// extracted by mini-css-extract-plugin
export var alternate = "_i-h";
export var black = "_i-3";
export var blue = "_i-d";
export var blueLight = "_i-c";
export var brand = "_i-7";
export var error = "_i-9";
export var gray = "_i-6";
export var grayBlue = "_i-b";
export var iconWrapper = "_i-4";
export var indigo = "_i-e";
export var orange = "_i-g";
export var pink = "_i-f";
export var primary = "_i-0";
export var purple = "_i-8";
export var success = "_i-5";
export var warning = "_i-a";
export var white = "_i-1";
export var whiteSuccess = "_i-2";